<template>
	<div class="main-top-bar">
		<div class="row-1 f-cb">
			<span class="addr f-fl f-toe1" v-if="item.area">{{item.area}}</span>
			<span class="name f-fl f-toe1">{{item.userName || item.userName}}</span>
		</div>
		<div class="row-2">
			<span class="praise-btn f-fr">{{item.likes}}</span>
			<span class="time">{{item.time | dateNewComment}}</span>
			
		</div>
	</div>
</template>

<script>
export default {
	props: ['item']
}	
</script>


// WEBPACK FOOTER //
// main-top-bar.vue?b700e070